module.exports = __webpack_public_path__ + "img/xinzhuang-5.e745eef5.jpg";